import React from "react";
import MuiIconChevronLeft from "@mui/icons-material/ChevronLeft";
import MuiIconChevronRight from "@mui/icons-material/ChevronRight";

// Source
import ControllerPagination from "../controller/Pagination";
import * as ModelPagination from "../model/Pagination";

let isRendered = false;

const viewPagination: React.FC<ModelPagination.Iprops> = (props) => {
    // Variable
    const controllerPagination = new ControllerPagination(props, isRendered);

    // Method
    controllerPagination.initializeHook();

    // Render
    isRendered = true;

    return (
        <div className="view_pagination">
            {(() => {
                const html: JSX.Element[] = [];

                const calculatePage = controllerPagination.calculatePage();

                if (calculatePage.current > 1) {
                    html.push(
                        <div
                            className="icon"
                            onClick={() => {
                                controllerPagination.clickGoToPage("left");
                            }}
                        >
                            <MuiIconChevronLeft />
                        </div>
                    );
                }

                if (controllerPagination.getGroupPage > 1) {
                    html.push(
                        <div className="number" onClick={controllerPagination.clickPreviousGroup}>
                            <p>...</p>
                        </div>
                    );
                }

                for (let a = controllerPagination.getStartPage; a <= controllerPagination.getEndPage; a++) {
                    html.push(
                        <div
                            className={`number ${calculatePage.current === a ? "active" : ""}`}
                            onClick={() => {
                                controllerPagination.clickGoToPage("center", a);
                            }}
                        >
                            <p>{a}</p>
                        </div>
                    );
                }

                if (controllerPagination.getGroupPage < controllerPagination.getTotalGroupPage) {
                    html.push(
                        <div className="number" onClick={controllerPagination.clickNextGroup}>
                            <p>...</p>
                        </div>
                    );
                }

                if (calculatePage.current < calculatePage.total) {
                    html.push(
                        <div
                            className="icon"
                            onClick={() => {
                                controllerPagination.clickGoToPage("right");
                            }}
                        >
                            <MuiIconChevronRight />
                        </div>
                    );
                }

                return html;
            })()}
        </div>
    );
};

export default viewPagination;
